import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
    return (
        <footer className="bg-slate-900 text-white py-12">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid md:grid-cols-5 gap-8">
                    <div className="md:col-span-2">
                        <div className="flex items-center mb-4">
                            <img
                                src="/Logo5.png"
                                alt="Northbridge Valuation & Advisory"
                                className="w-[200px] h-auto"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                        <p className="text-slate-400 mb-4 max-w-md">
                            <span className="block mb-2">CVA & CPA • Court-Nominable</span>
                            <span className="block">Independent, defensible valuations for critical decisions.</span>
                        </p>
                        <div className="flex space-x-4">
                            <a
                                href="https://www.linkedin.com/company/northbridgevaluation"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-slate-400 hover:text-white transition-colors"
                            >
                                <Icon name="Linkedin" size={20} />
                            </a>
                            <a
                                href="mailto:info@northbridgevaluation.com"
                                className="text-slate-400 hover:text-white transition-colors"
                            >
                                <Icon name="Mail" size={20} />
                            </a>
                            <a
                                href="tel:307-458-3950"
                                className="text-slate-400 hover:text-white transition-colors"
                            >
                                <Icon name="Phone" size={20} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-semibold mb-4">Services</h3>
                        <ul className="space-y-2 text-slate-400">
                            <li><Link to="/valuation" className="hover:text-white transition-colors">Business Valuation</Link></li>
                            <li><Link to="/litigation-support" className="hover:text-white transition-colors">Litigation Support</Link></li>
                            <li><Link to="/services" className="hover:text-white transition-colors">All Services</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-semibold mb-4">Company</h3>
                        <ul className="space-y-2 text-slate-400">
                            <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-semibold mb-4">Contact</h3>
                        <div className="space-y-2 text-slate-400">
                            <p>
                                <a href="tel:307-458-3950" className="hover:text-white transition-colors">
                                    307-458-3950
                                </a>
                            </p>
                            <p>
                                <a href="mailto:info@northbridgevaluation.com" className="hover:text-white transition-colors">
                                    info@northbridgevaluation.com
                                </a>
                            </p>
                            <p>316 S Gillette Ave Suite 150</p>
                            <p>Gillette, WY 82716</p>
                        </div>
                    </div>
                </div>

                <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-slate-400">
                    <p>&copy; {new Date().getFullYear()} Northbridge Valuation & Advisory. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
                        <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
                        <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
